export default function useCheckboxGroup({ data, props, emit }) {
  const mapValue = {}

  const setValue = () => {
    return props.sources
      .filter((source) => data.value.includes(source.code))
      .map((source) => ({ code: source.code, name: source.name }))
  }
  const change = (val, item) => {
    if (!val) {
      remove(item.code)
    } else {
      add(item.code)
    }

    emit('input', setValue())
  }

  // 遍历 props.sources 选中已选项
  const selected = () => {
    props.sources.forEach((source) => {
      mapValue[source.code] = data.value.includes(source.code)
    })
  }
  // 查找是否已选中并得到下标
  const search = (code) => data.value.findIndex((checked) => checked === code)
  // 选中
  const add = (code) => {
    const nIndex = search(code)
    if (nIndex < 0) data.value.push(code)
    selected()
  }
  // 移除
  const remove = (code) => {
    const nIndex = search(code)
    if (nIndex > -1) data.value.splice(nIndex, 1)
    selected()
  }

  // 初始化
  const init = () => {
    props.value?.forEach((item) => {
      add(item.code)
    })
  }

  return { mapValue, init, add, remove, change }
}
